import { useLazyQuery, useMutation } from "@apollo/client";
import { AvailableGamesQuery } from "../gql/queries";
import { JoinGameMutation } from "../gql/mutations";
import { useEffect, useState } from "react";
import { MAX_PLAYERS } from "../config";

interface JoinGameStatus {
  loading: boolean;
  called: boolean;
  error: any;
  data: any;
}
const userWasAddedToGame = (game: any, playerId: string) => {
  for (let i = 1; i <= MAX_PLAYERS; i++) {
    const player = game[`Player_${i}`];
    if (player === playerId) return true;
  }
  return false;
};

export const useJoinGame = (
  playerId: string,
  playerDisplayName: string,
  wantToJoinGameId?: string
): [Function, JoinGameStatus] => {
  const [getGames, getGamesStatus] = useLazyQuery(AvailableGamesQuery, {
    fetchPolicy: "no-cache"
  });
  const [joinGame, joinGameStatus] = useMutation(JoinGameMutation, {
    fetchPolicy: "no-cache"
  });
  const [loading, setLoading] = useState(false);
  const [called, setCalled] = useState(false);
  const [data, setData] = useState<null | string>(null);
  const [error, setError] = useState<null | string>(null);

  const joinGameFunc = (gameId?: string) => {
    setCalled(true);
    setLoading(true);

    //do we have a game we want to join
    if (wantToJoinGameId) {
      //console.log("WE WANT TO JOIN THIS GAME: ", wantToJoinGameId)

      // @jason
      // need to check if game exists or is full here
      // and return an error if so

      joinGame({
        variables: {
          id: wantToJoinGameId,
          playerId: playerId,
          playerDisplayName: playerDisplayName
        }
      });
    } else {
      //console.log("WE ARE LOOKING FOR A GAME")
      getGames();
    }
  };

  useEffect(() => {
    const gamesData = getGamesStatus.data;
    if (!getGamesStatus.loading && gamesData && gamesData.getAvailableGames) {
      if (gamesData.getAvailableGames.length > 0) {
        const {
          id,
          Player_1,
          Player_2,
          Player_3,
          Player_4
        } = gamesData.getAvailableGames[0];

        console.log("GAME DATA:", gamesData.getAvailableGames[0]);

        console.log("GAME DATA:", id, Player_1, Player_2);

        //check if user is in game
        let userInGame = userWasAddedToGame(
          gamesData.getAvailableGames[0],
          playerId
        );
        if (userInGame) {
          console.log("USER ALREADY IN GAME: ", id);
          setData(id); //send back existing game id
          return;
        }

        //join first game
        joinGame({
          variables: {
            id: id,
            playerId: playerId,
            playerDisplayName: playerDisplayName
          }
        });
      } else {
        setLoading(false);
        setError("no-games");
        // NO GAMES TO JOIN
      }
    }
  }, [getGames, getGamesStatus, joinGame, playerDisplayName, playerId]);

  useEffect(() => {
    const { called, loading, error, data } = joinGameStatus;
    setLoading(loading);
    if (error) {
      setError(error.message);
    } else if (called && !loading && data) {
      const joinedGame = data.joinGameByIdPipeline;
      if (
        joinedGame !== undefined &&
        userWasAddedToGame(joinedGame, playerId)
      ) {
        setData(joinedGame.id);
      } else {
        setError("join-error");
      }

      // Check that user UUID successfully joined game
      // show friendly error
    }
  }, [joinGameStatus, playerId]);

  return [joinGameFunc, { loading, called, error, data }];
};
